import React from 'react';
import './Card.css';

function Card({
  title,
  content,
  frameImage,
  secondaryFrameImage, // Optional second image
  height = "400px", // Default height for desktop
  mobileHeight = "250px", // New variable for mobile height
  imageStyle = {}, // Style for the primary image (desktop)
  mobileImageStyle = {}, // Style for the primary image (mobile)
  secondaryImageStyle = {}, // Style for the secondary image (desktop)
  mobileSecondaryImageStyle = {}, // Style for the secondary image (mobile)
  textPosition = {}, // Style for text positioning (desktop)
  mobileTextPosition = {}, // Style for text positioning (mobile)
}) {
  // Determine if the viewport is mobile
  const isMobile = window.innerWidth <= 1200;

  console.log('Mobile Text Position:', isMobile ? mobileTextPosition : textPosition); // Debugging

  return (
    <div
      className="card"
      style={{
        '--card-height': isMobile ? mobileHeight : height, // Use mobileHeight if in mobile view
      }}
    >
      {/* Banner at the top */}
      <div className="card-banner">
        <h2>{title}</h2>
      </div>

      {/* Body for image and content */}
      <div className="card-body">
        {/* Primary Image */}
        {frameImage && (
          <div
            className="card-image primary"
            style={{
              '--frame-image': `url(${frameImage})`,
              ...(isMobile ? mobileImageStyle : imageStyle), // Apply appropriate styles
            }}
          />
        )}

        {/* Secondary Image */}
        {secondaryFrameImage && (
          <div
            className="card-image secondary"
            style={{
              '--frame-image': `url(${secondaryFrameImage})`,
              ...(isMobile ? mobileSecondaryImageStyle : secondaryImageStyle), // Apply appropriate styles
            }}
          />
        )}

        {/* Text Content */}
        <div
          className="card-content"
          style={{
            ...(isMobile ? mobileTextPosition : textPosition), // Apply appropriate styles
          }}
        >
          <ul>
            {content.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Card;
